module.exports = require('./helpers/bundle-url').getBundleURL('fSmkK') + "logo-dark.ba5147f0.svg";